module.exports = __webpack_public_path__ + "static/img/logo.562852b4.png";